export enum VacationTypes{
  NOT_CHOSEN,
  PAID_LEAVE,
  UNPAID_LEAVE,
  SICK_LEAVE,
  BUSINESS_TRIP
};


// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/vacation-Types.ts